import { appConfig } from '@/config/app.ts'

export interface InsuranceRentabilityState {
  isLoading: boolean
  isCreateModalOpen: boolean
  editId: string | null
  filters: string
}

export const initialState: InsuranceRentabilityState = {
  isLoading: false,
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
